type RequestCentrifugoTokenResponse = {
  token: string;
};

export async function requestCentrifugoToken(accessToken: string): Promise<string> {
  const apiBase =
    process.env.NEXT_PUBLIC_API_URL || process.env.NEXT_PUBLIC_API_BASE_URL;

  if (!apiBase) {
    throw new Error(
      "Missing NEXT_PUBLIC_API_URL (preferred) or NEXT_PUBLIC_API_BASE_URL"
    );
  }

  const res = await fetch(`${apiBase}/api/centrifugo/request-token.json`, {
    method: "POST",
    headers: {
      Authorization: `Bearer ${accessToken}`,
      "Content-Type": "application/json",
    },
    body: JSON.stringify({}),
  });

  const data = (await res.json()) as Partial<RequestCentrifugoTokenResponse>;

  return data.token!;
}